<template>
  <div class="comContent">
    <div class="header">
      <Tabs :tabsList="tabsList" style="padding: 0 24px" :activeName="activeVal" @tab-click="handleChange">
      </Tabs>
    </div>
    <div class="center">
      <PersonManagerView v-if="activeVal == '1'" @changeTab="handleChangeTab" />
      <CertificationsManagerView v-if="activeVal == '2'" />
      <DetailRevenueView v-if="activeVal == '3'" :salesJobNumber="salesJobNumber " />
      <PayoutsPipeLineView v-if="activeVal == '4'" :salesJobNumber="salesJobNumber " />
    </div>
  </div>
</template>

<script>
import Tabs from "@/components/Tabs";
import PersonManagerView from "./children/personManager.vue";
import CertificationsManagerView from "./children/CertificationsManager.vue";
import DetailRevenueView from "./children/DetailRevenue.vue";
import PayoutsPipeLineView from "./children/PayoutsPipeLine.vue";

export default {
  components: {
    Tabs,
    PersonManagerView,
    CertificationsManagerView,
    DetailRevenueView,
    PayoutsPipeLineView,
  },
  data() {
    return {
      activeVal: "1",
      salesJobNumber:'',
      tabsList: [
        {
          name: "1",
          label: "人员管理",
          value: 0,
        },
        {
          name: "2",
          label: "认证列表",
          value: 0,
        },
        {
          name: "3",
          label: "收入明细",
          value: 0,
        },
        {
          name: "4",
          label: "提现流水",
          value: 0,
        },
      ],
    };
  },
  destroyed() {
    this.unInitEvent();
  },
  methods: {
    unInitEvent() {
      this.$bus.$off("refresh");
    },
    handleChange(val) {
      this.activeVal = val;
    },
    handleChangeTab(portableData) {
      if (portableData) {
        this.activeVal = portableData.tabindex;
        this.salesJobNumber = portableData.row.salesJobNumber;
        //设置完了后，赋空
        this.$nextTick(() => {
          this.salesJobNumber = "";
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comContent {
  padding: 0px;
  box-sizing: border-box;
}

.header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px 0px 24px !important;
  border-bottom: 1px solid #f5f5f5;
  box-sizing: border-box;
}

.center {
  margin-top: 16px;
  padding: 0 24px 0 24px;
  box-sizing: border-box;
  overflow: auto;
  height: calc(100% - 100px);
}

.el-page {
  padding: 10px 24px !important;
}
</style>
